import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { copyDomNode, toDOM } from '@atlaskit/editor-common/copy-button';
import { TextSelection } from '@atlaskit/editor-prosemirror/state';
import { findSelectedNodeOfType, removeParentNodeOfType, removeSelectedNode } from '@atlaskit/editor-prosemirror/utils';
import { canBeConvertedToSyncBlock, findSyncBlock, findSyncBlockOrBodiedSyncBlock, isBodiedSyncBlockNode } from '../pm-plugins/utils/utils';
export var createSyncedBlock = function createSyncedBlock(_ref) {
  var tr = _ref.tr,
    syncBlockStore = _ref.syncBlockStore,
    typeAheadInsert = _ref.typeAheadInsert;
  var _tr$doc$type$schema$n = tr.doc.type.schema.nodes,
    bodiedSyncBlock = _tr$doc$type$schema$n.bodiedSyncBlock,
    paragraph = _tr$doc$type$schema$n.paragraph;

  // If the selection is empty, we want to insert the sync block on a new line
  if (tr.selection.empty) {
    var attrs = syncBlockStore.sourceManager.generateBodiedSyncBlockAttrs();
    var paragraphNode = paragraph.createAndFill({});
    var newBodiedSyncBlockNode = bodiedSyncBlock.createAndFill(attrs, paragraphNode ? [paragraphNode] : []);
    if (!newBodiedSyncBlockNode) {
      return false;
    }

    // Save the new node with empty content to backend
    // This is so that the node can be copied and referenced without the source being saved/published
    syncBlockStore.sourceManager.createBodiedSyncBlockNode(attrs);
    if (typeAheadInsert) {
      tr = typeAheadInsert(newBodiedSyncBlockNode);
    } else {
      tr = tr.replaceSelectionWith(newBodiedSyncBlockNode).scrollIntoView();
    }
  } else {
    var conversionInfo = canBeConvertedToSyncBlock(tr.selection);
    if (!conversionInfo) {
      // TODO: EDITOR-1665 - Raise an error analytics event
      return false;
    }
    var _attrs = syncBlockStore.sourceManager.generateBodiedSyncBlockAttrs();
    var _newBodiedSyncBlockNode = bodiedSyncBlock.createAndFill(_attrs, conversionInfo.contentToInclude);
    if (!_newBodiedSyncBlockNode) {
      return false;
    }

    // Save the new node with empty content to backend
    // This is so that the node can be copied and referenced without the source being saved/published
    syncBlockStore.sourceManager.createBodiedSyncBlockNode(_attrs);
    tr.replaceWith(conversionInfo.from > 0 ? conversionInfo.from - 1 : 0, conversionInfo.to, _newBodiedSyncBlockNode).scrollIntoView();

    // set selection to the end of the previous selection + 1 for the position taken up by the start of the new synced block
    tr.setSelection(TextSelection.create(tr.doc, conversionInfo.to + 1));
  }

  // This transaction will be intercepted in filterTransaction and dispatched when saving to backend succeeds
  // see filterTransaction for more details
  return tr;
};
export var copySyncedBlockReferenceToClipboardEditorCommand = function copySyncedBlockReferenceToClipboardEditorCommand(_ref2) {
  var tr = _ref2.tr;
  if (copySyncedBlockReferenceToClipboardInternal(tr.doc.type.schema, tr.selection)) {
    return tr;
  }
  return null;
};
export var copySyncedBlockReferenceToClipboard = function copySyncedBlockReferenceToClipboard(state, _dispatch, _view) {
  return copySyncedBlockReferenceToClipboardInternal(state.tr.doc.type.schema, state.tr.selection);
};
var copySyncedBlockReferenceToClipboardInternal = function copySyncedBlockReferenceToClipboardInternal(schema, selection) {
  var syncBlockFindResult = findSyncBlockOrBodiedSyncBlock(schema, selection);
  if (!syncBlockFindResult) {
    return false;
  }
  var isBodiedSyncBlock = isBodiedSyncBlockNode(syncBlockFindResult.node, schema.nodes.bodiedSyncBlock);
  var referenceSyncBlockNode = null;
  if (isBodiedSyncBlock) {
    var syncBlock = schema.nodes.syncBlock;

    // create sync block reference node
    referenceSyncBlockNode = syncBlock.createAndFill({
      resourceId: syncBlockFindResult.node.attrs.resourceId
    });
    if (!referenceSyncBlockNode) {
      return false;
    }
  } else {
    referenceSyncBlockNode = syncBlockFindResult.node;
  }
  if (!referenceSyncBlockNode) {
    return false;
  }
  var domNode = toDOM(referenceSyncBlockNode, schema);
  copyDomNode(domNode, referenceSyncBlockNode.type, selection);
  return true;
};
export var editSyncedBlockSource = function editSyncedBlockSource(syncBlockStore, api) {
  return function (state, dispatch, _view) {
    var _syncBlock$node;
    var syncBlock = findSyncBlock(state.schema, state.selection);
    var resourceId = syncBlock === null || syncBlock === void 0 || (_syncBlock$node = syncBlock.node) === null || _syncBlock$node === void 0 || (_syncBlock$node = _syncBlock$node.attrs) === null || _syncBlock$node === void 0 ? void 0 : _syncBlock$node.resourceId;
    if (!resourceId) {
      return false;
    }
    var syncBlockURL = syncBlockStore.referenceManager.getSyncBlockURL(resourceId);
    if (syncBlockURL) {
      window.open(syncBlockURL, '_blank');
    } else {
      var _api$analytics;
      var tr = state.tr;
      api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.attachAnalyticsEvent({
        eventType: EVENT_TYPE.OPERATIONAL,
        action: ACTION.ERROR,
        actionSubject: ACTION_SUBJECT.SYNCED_BLOCK,
        actionSubjectId: ACTION_SUBJECT_ID.SYNCED_BLOCK_SOURCE_URL,
        attributes: {
          error: 'No URL resolved for synced block'
        }
      })(tr);
      dispatch === null || dispatch === void 0 || dispatch(tr);
    }
    return true;
  };
};
export var removeSyncedBlock = function removeSyncedBlock(api) {
  return function (state, dispatch, _view) {
    var nodes = state.schema.nodes,
      tr = state.tr;
    if (!dispatch) {
      return false;
    }
    var removeTr = tr;
    if (findSelectedNodeOfType(nodes.syncBlock)(tr.selection) || findSelectedNodeOfType(nodes.bodiedSyncBlock)(tr.selection)) {
      removeTr = removeSelectedNode(tr);
    } else {
      removeTr = removeParentNodeOfType(nodes.bodiedSyncBlock)(tr);
    }
    if (!removeTr) {
      return false;
    }
    dispatch(removeTr);
    api === null || api === void 0 || api.core.actions.focus();
    return true;
  };
};